<template>
	<div class="layout-base">


		<Layout>
			<Header class="layout-header-one"><img id="layout-logo" style=" padding-top:20px; height: 100px; "
					:src="require('./assets/image/logo.png')"></Header>
			<Header class="layout-header-two"></Header>
			<Layout>
				<Sider class="layout-sider" hide-trigger width=100> </Sider>
				<Layout>
					<Content class="layout-content">
						<img id="layout-logo" style="position:absolute;top: 380px;left:23%; width: 50%; height: 80%;"
							:src="require('./assets/image/name.png')">
						<div style="padding-top: 8%; height: 60%  ; ">
							<Form class="aaa" ref="formValidate" label-position="right" :model="formValidate"
								:rules="ruleValidate" :label-width="140">
								<Row type="flex" align="middle">
									<FormItem  prop="phone" >
										 <div slot='label'>手机号码:<br><span style="font-size: 10px;">（付费用户支付凭证）</span></div>
										<Input v-model="formValidate.phone"  ref="phone" size="large" placeholder="手机号码" > </Input>

									</FormItem>
								</Row>
								<Row type="flex" align="middle">

									<FormItem label="姓   氏:" prop="xingShi">
										<Input v-model="formValidate.xingShi" size="large" placeholder="请输入姓氏"></Input>
									</FormItem>

								</Row>
								<Row type="flex" align="middle">
									<FormItem label="性      别:" prop="sex">
										<RadioGroup v-model="formValidate.sex">
											<Radio label="0"> <span class="spanStyle">未知</span></Radio>
											<Radio label="1"> <span class="spanStyle">男</span></Radio>
											<Radio label="2"> <span class="spanStyle">女</span></Radio>
										</RadioGroup>
									</FormItem>
								</Row>
								<Row type="flex" align="middle">
									<FormItem label="名字长度:" prop="nameSize">
										<RadioGroup v-model="formValidate.nameSize" type="button" button-style="solid">
											<Radio label="2"><span class="spanStyle">2字</span></Radio>
											<Radio label="3"><span class="spanStyle">3字</span></Radio>
											<Radio label="4"><span class="spanStyle">4字</span></Radio>
										</RadioGroup>


									</FormItem>
								</Row>

								<Row type="flex" align="middle">
									<FormItem label="固定字:" prop="specialWord">
										<Input v-model="formValidate.specialWord" size="large" maxlength="1"
											placeholder="请输入固定字"> </Input>

									</FormItem>
								</Row>

								<Row type="flex" align="middle">
									<FormItem label="固定字位置:" prop="specialWord">
										<RadioGroup v-model="formValidate.location">
											<Radio label="2"><span class="spanStyle">第二字</span></Radio>
											<Radio label="3"><span class="spanStyle">第三字</span></Radio>
											<Radio label="4"><span class="spanStyle">第四字</span></Radio>
										</RadioGroup>
									</FormItem>
								</Row>

								<Row type="flex" align="middle">
									<FormItem label="生  日:" prop="birthday">
										<DatePicker type="date" placeholder="请选择日期" style="width: 120px" />
										<TimePicker type="time" placeholder="请选择时间" style="width: 120px" />
									</FormItem>
								</Row>




								<Row type="flex" align="middle">
									<FormItem>
										<Button type="primary" @click="handleSubmit('formValidate')">起名</Button>
										<Button @click="handleReset('formValidate')"
											style="margin-left: 20px">重置</Button>
									</FormItem>
								</Row>

								<Row type="flex" align="middle">
									<Col span="9">
									<!-- <Modal v-model="modal1" title="购买服务" @on-ok="ok" @on-cancel="cancel"> -->
									<Modal v-model="modal1" title="购买服务" @on-cancel="cancel">
										<Form    	:label-width="150">

										 
											<Row>
												<Col align="center" :span="24">
												<div>您要购买的起名字服务9.9元，有效期两天</div>
												<div>再次使用时请填写付款时填写的电话号码</div>
												<div style="font-size: 50px;">微信支付</div>
												<!-- <img id="head-logo" :src="require('@/assets/image/weixinpay.png')"> -->
												<div ref="twoImageRef" id="twoImageId"></div>
												</Col>
											</Row>
										</Form>
										<!-- 这里去掉确认和取消按钮 -->
										<div slot="footer"></div>
									</Modal>
									</Col>
								</Row>
							</Form>
						</div>
						<div style="padding-left: 20%; padding-top:12%">

							<Row>
								<Col span="7">
								<div class="page-before" style="cursor:pointer; width: 100px; height: 68px;"
									@click="before()">
								</div>
								</Col>
								<Col span="8">
								<div class="test" style="width: 150px; height: 68px;  ">
									<span
										style="display:table-cell;text-align:center;vertical-align:middle;color:#EDDDA9;font-size: 18px; font-family: 华文行楷;">
										共{{count}}个好名字
									</span>
								</div>
								</Col>
								<Col span="8">
								<div class="page-after" style="cursor:pointer;  width: 100px; height: 68px;"
									@click="after()">
								</div>
								</Col>
							</Row>
						</div>

						<div style="padding-left: 20%;  padding-top: 3%;  ">
							<div v-for="item in data1" style="  text-align:center;height: 7%; width: 7%; float: left; display: flex;
								flex-direction: column; ">

								<img style="width: 56%;height: 56%;"
									:src="require('./assets/head/' +item.orderNum+'.png')">
								<span class="spanStyle">{{item.name}} </span>
							</div>

						</div>
					</Content>
				</Layout>

				<Sider class="layout-sider" hide-trigger width=100> </Sider>
			</Layout>
			<Footer class="layout-footer">

			</Footer>
			<Footer class="foot-back">

				<div>
					<h1>常见问题解答</h1>
					<!-- <div style="padding-left: 30%; text-align: left ; ">
						<li style="padding-top: 20px; font-size: 22px; ">1、该网站起名字收费么？</li>
						<span style="font-size: 20px;">答：本站免费提供给用户使用，不收取任何费用。</span>
					</div>  -->
					<div style="padding-left: 30%; text-align: left ; ">
						<li style="padding-top: 20px; font-size: 22px; ">1、收费和免费的区别？</li>
						<span style="font-size: 20px;">答：免费只能提供10个以内的名字，收费则可以查看所有符合条件的名字。</span>
						<li style="font-size: 22px;">2、收费的有效期是多少时间？</li>
						<span style="font-size: 20px;">答：有效期为2天。</span>
						<li style="font-size: 22px;">3、浏览器关闭如何在有效期内再次使用？</li>
						<span style="font-size: 20px;">答：交费时会要求填写“手机号码”，再次查询时起名字的查询条件里输入交费时填写的手机号码即可。</span>
						<li style="font-size: 22px;">4、遇到问题如何解决？</li>
						<span style="font-size: 20px;">答：发送邮件2431886055@qq.com,24小时内为您解决问题。</span>
					</div>
					<!-- 	<li style="font-size: 22px;">4、有效期内是否可以给其他人使用？</li>
						<span style="font-size: 20px;">答：交费时手机号码会与姓氏绑定，一个手机号码绑定一个姓氏，如果其他人姓氏和您的姓氏不一样则无法使用。</span>
					 -->
					<div> {{dayAccessNum}} | {{dayMoneyNum}} </div>
				</div>
			</Footer>
			<Footer style="background-color: gainsboro;">
				<Layout>
					<div align="center" style="background-color: gainsboro;">
						Copyright © 乌鲁木齐市木简网络科技有限公司  版权所有 All Rights Reserved.
					</div>
					<div align="center" style="background-color: gainsboro;">
						备案号:  新ICP备2021000783号
					</div>
					<!-- <div id="friendSrc" align="center" style="background-color: gainsboro;">
						友情链接：老虎IT学院 | SQL在线学习
					</div>
					
					
					<div style="background-color: gainsboro;"> {{dayAccessNum}} | {{dayMoneyNum}} </div> -->
				</Layout>
			</Footer>
		</Layout>


	</div>
</template>

<script>
	import {
		getName,
		getDayAccess,
		getNameMoney,
		dayAccessAdd,
		createTwoImage,
		moneyAdd,
		getNumMoney,
	} from '@/network/index.js';
	import QRCode from 'qrcodejs2'
	const paramter = {
		page: 1,
		pagesize: 10,
		ispage: 'Y',
	};
	export default {
		name: 'App',
		components: {

		},
		data() {
			// //手机号码验证
			const validatePhone = (rule, value, callback) => {

				if (value != '') {
					if (!/^1[34578]\d{9}$/.test(value)) {
						callback('手机号格式不正确');
					} else {
						callback();
					}
				} else {
					callback();
				}
			};

			return {
				formValidate: {
					xingShi: '',
					sex: '0',
					nameSize: '2',
					specialWord: '',
					location: '2',
					birthday: '',
					phone: '',
				},
				 
				ruleValidate: {
					xingShi: [{
						required: true,
						message: '姓氏是必填项',
						trigger: 'blur' //失去焦点事件
					}],
					phone: [{
						validator: validatePhone,
						trigger: 'blur' //失去焦点事件
					}],
				},
				 
				twoImage: '',
				count: 0,
				page: 0,
				data1: [],
				dayAccessNum: 0,
				dayMoneyNum: 0,
				ifMoney: 0,
				modal1: false,
				flag: true,

			}
		},

		created() {
			//浏览页面新增
			dayAccessAdd().then(res => {}).catch(error => {});


			//获取当天访问人数
			getDayAccess().then(res => {
				this.dayAccessNum = res.data.obj.dataList.length;
			}).catch(error => {});

			//获取当天付款人数
			getNumMoney().then(res => {
				this.dayMoneyNum = res.data.obj.length;
			}).catch(error => {});


		},
		mounted() {
			this.checkPayStatus()
		},

		methods: {
	 

			//上一页
			before() {
				if (this.page == 1) {
					this.$Message.info('已经是第一页了！');
					return;
				}
				this.page = this.page - 1
				let paramter = {
					page: this.page,
					pagesize: 10,
					ispage: 'Y',
					xingShi: this.formValidate.xingShi,
					sex: this.formValidate.sex,
					nameSize: this.formValidate.nameSize,
					specialWord: this.formValidate.specialWord,
					location: this.formValidate.location,
					specialWord: this.formValidate.specialWord,
				};

				getName(paramter).then(res => {
					// console.log(res);
					this.count = res.data.page.count;

					//数据清空
					this.data1 = [];
					for (var i = 0; i < res.data.obj.dataList.length; i++) {
						this.data1.push({
							name: res.data.obj.dataList[i].name,
							orderNum: i + 1,
						});
					}

				}).catch(error => {});
			},
			//下一页
			after() {
				//付费校验
				let paramterMoney = {
					phone: this.formValidate.phone,
				};
				getNameMoney(paramterMoney).then(res => {
					// console.log(res);
					this.ifMoney = res.data.obj;

					if (this.ifMoney == 1) {
						this.flag = false
						if (this.page * 10 >= this.count) {
							this.$Message.info('没有更多的名字了！');
							return;
						}
						this.page = this.page + 1;
						let paramter = {
							page: this.page,
							pagesize: 10,
							ispage: 'Y',
							xingShi: this.formValidate.xingShi,
							sex: this.formValidate.sex,
							nameSize: this.formValidate.nameSize,
							specialWord: this.formValidate.specialWord,
							location: this.formValidate.location,
							specialWord: this.formValidate.specialWord,
						};

						getName(paramter).then(res => {
							// console.log(res);
							this.count = res.data.page.count;

							//数据清空
							this.data1 = [];
							for (var i = 0; i < res.data.obj.dataList.length; i++) {
								this.data1.push({
									name: res.data.obj.dataList[i].name,
									orderNum: i + 1,
								});
							}

						}).catch(error => {});


					} else {
						//付款前请收入手机号码
						if (this.formValidate.phone == '') {
							this.$Message.info('查看更多的名字，请输入手机号码！');
							this.$refs.phone.focus()
							return;
						} else {

							//生成收费的二维码
							let paramter = {
								attach: this.formValidate.phone,
							};
							//清空之前的二维码 否则会生成多个
							this.$refs.twoImageRef.innerHTML = '';
							createTwoImage(paramter).then(res => {
								this.twoImage = res.code_url;
								//$('#twoImageClass').html("");
								//$('#twoImageClass').empty()
								this.generateQRCode("#twoImageId", this.twoImage);
							}).catch(error => {});

							//弹出对话框，要求付费
							this.modal1 = true

						}
					}

				}).catch(error => {});

			},

			checkPayStatus() {
				//付费校验
				if (this.formValidate.phone != '') {
					let paramterMoney = {
						phone: this.formValidate.phone,
					};
					getNameMoney(paramterMoney).then(res => {
						// console.log(res);
						this.ifMoney = res.data.obj;
						if (this.ifMoney == 1) {
							//关闭弹出窗
							this.modal1 = false
							this.flag = false
						} else {
							setTimeout(() => {
								this.checkPayStatus() // 等待一段时间后再次调用checkPayStatus方法
							}, 1000)
						}
					})
				}else{
					setTimeout(() => {
						this.checkPayStatus() // 等待一段时间后再次调用checkPayStatus方法
					}, 1000)
				}
			},

			cancel() {
				this.flag = false
			},
			//生成二维码
			generateQRCode(classId, value) {
				new QRCode(document.querySelector(classId), {
					text: value,
					width: 180,
					height: 180,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H
				})
			},

			//查询
			handleSubmit(name) {
				
				
				this.$refs[name].validate((valid) => {
					if (valid) {
						let paramter = {
							page: 1,
							pagesize: 10,
							ispage: 'Y',
							xingShi: this.formValidate.xingShi,
							sex: this.formValidate.sex,
							nameSize: this.formValidate.nameSize,
							specialWord: this.formValidate.specialWord,
							location: this.formValidate.location,
							specialWord: this.formValidate.specialWord,
						};

						getName(paramter).then(res => {
							// console.log(res);
							this.count = res.data.page.count;
							this.page = res.data.page.page;
							//数据清空
							this.data1 = [];
							for (var i = 0; i < res.data.obj.dataList.length; i++) {
								this.data1.push({
									name: res.data.obj.dataList[i].name,
									orderNum: i + 1,
								});
							}

						}).catch(error => {});
					} else {
						this.$Message.error('数据校验失败!请检查姓氏和手机号码是否正确');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		}

	}
</script>


<style lang="scss">
	.layout-base {
		text-align: center;
	}


	.layout-logo {
		width: 100px;
		height: 30px;
		background: #5b6270;
		border-radius: 3px;
		float: left;
		position: relative;
		top: 15px;
		left: 20px;
	}



	.layout-header-one {
		background: url('~@/assets/image/header.png');
		height: 120px;
		//下边框 金色
		border-bottom: 5px solid #EDDDA9;
	}

	.layout-header-two {
		//	background: url('~@/assets/image/top1.png') no-repeat 0px 0px ;
		background: url('~@/assets/image/top2.png') no-repeat center 0px;
		background-position: center 0px;
		background-size: cover;
		text-indent: -999px;

		color: white;
		height: 247px;
		//下边框 金色
		border-bottom: 5px solid #EDDDA9;
	}



	.layout-content {
		background: url('~@/assets/image/background.jpg');

		//min-height: 120px;
		//line-height: 120px;
	}

	.layout-sider {
		background: url('~@/assets/image/background.jpg');
	}

	.layout-footer {
		height: 500px;
		color: white;

		background: url('~@/assets/image/biaoZhun.png') no-repeat center 0px;
		background-size: 100% 100%;
		border-bottom: 5px solid #EDDDA9;
		border-top: 5px solid #EDDDA9;
	}

	.layout-rule {
		height: 500px;
		color: white;
		//background: url('~@/assets/image/biaoZhun.png') no-repeat center 0px;
		border-bottom: 5px solid #EDDDA9;

	}

	.layout-footer-center {
		text-align: center;

	}

	// .biaozhun {
	// 	width: 100%;
	// 	height: 100%;
	// 	background: url('~@/assets/image/biaoZhun.png') no-repeat center 0px;
	// 	background-size:100% 100%;
	// }


	//改变字体大小
	.aaa.ivu-form .ivu-form-item-label {
		font-size: 24px;
	}

	.aaa {
		padding-left: 35%;
		padding-top: 0%;
	}

	.spanStyle {
		font-size: 20px;
		text-align: left;
		padding-left: 4px;
	}

	.ivu-card-body {
		width: 0px;
		height: 0px;
	}

	.page-before {
		//	background: url('~@/assets/image/top1.png') no-repeat 0px 0px ;
		background: url('~@/assets/page/before.png') no-repeat center 0px;

	}

	.page-all {


		background: url('~@/assets/page/all.png') no-repeat center 0px;
		//display:table-cell;
		vertical-align: middle;
		text-align: center;
	}


	.test {
		//background: url('~@/assets/page/all.png') no-repeat center 0px;
		//display: table-cell;
		float: left;
		vertical-align: middle;
		//text-align: center;

		height: 100px;
		display: table;
		width: 100px;
		background: url('~@/assets/page/all.png') no-repeat center 0px;
	}

	.page-after {
		background: url('~@/assets/page/after.png') no-repeat center 0px;

	}

	#friendSrc {
		left: 30%;

		font-size: 20px; //设置字体大小

		font-family: "PingFang SC";
		padding: 3px;
		bottom: 0;

		border-style: solid;
		border-width: 0px;
		border-color: #f0f3ff;

	}

	//如下是规则说明的样式

	.foot-back {
		text-align: center;
		background: url('~@/assets/image/background.jpg');
		border-bottom: 5px solid #EDDDA9;
	}
</style>
